import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Input } from '@/components/ui/input';
import { AVAILABLE_INTEGRATIONS } from '@/constants/metrics';

interface IntegrationsConfigProps {
  mode: 'predefined' | 'customizable';
  maxIntegrations: number;
  allowedIntegrations: string[];
  onModeChange: (mode: 'predefined' | 'customizable') => void;
  onMaxIntegrationsChange: (max: number) => void;
  onAllowedIntegrationsChange: (integrations: string[]) => void;
}

export function IntegrationsConfig({
  mode,
  maxIntegrations,
  allowedIntegrations,
  onModeChange,
  onMaxIntegrationsChange,
  onAllowedIntegrationsChange,
}: IntegrationsConfigProps) {
  const handleToggle = (integration: string) => {
    if (allowedIntegrations.includes(integration)) {
      onAllowedIntegrationsChange(allowedIntegrations.filter((i) => i !== integration));
    } else {
      onAllowedIntegrationsChange([...allowedIntegrations, integration]);
    }
  };

  return (
    <div className="space-y-4">
      <Label>Configuração de Integrações</Label>
      
      <RadioGroup value={mode} onValueChange={(v) => onModeChange(v as 'predefined' | 'customizable')}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="predefined" id="integrations-predefined" />
          <label htmlFor="integrations-predefined" className="text-sm cursor-pointer">
            Pré-definido (SuperAdmin escolhe quais integrações)
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="customizable" id="integrations-customizable" />
          <label htmlFor="integrations-customizable" className="text-sm cursor-pointer">
            Customizável (Admin escolhe dentro de um limite)
          </label>
        </div>
      </RadioGroup>

      {mode === 'predefined' ? (
        <div className="space-y-3 p-4 border rounded-lg bg-muted/50">
          <Label>Integrações Permitidas</Label>
          <div className="grid grid-cols-2 gap-3">
            {AVAILABLE_INTEGRATIONS.map((integration) => (
              <div key={integration} className="flex items-center space-x-2">
                <Checkbox
                  id={`integration-${integration}`}
                  checked={allowedIntegrations.includes(integration)}
                  onCheckedChange={() => handleToggle(integration)}
                />
                <label
                  htmlFor={`integration-${integration}`}
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                >
                  {integration}
                </label>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="space-y-2 p-4 border rounded-lg bg-muted/50">
          <Label htmlFor="max-integrations">Máximo de Integrações</Label>
          <Input
            id="max-integrations"
            type="number"
            min="0"
            max={AVAILABLE_INTEGRATIONS.length}
            value={maxIntegrations}
            onChange={(e) => onMaxIntegrationsChange(parseInt(e.target.value) || 0)}
          />
          <p className="text-xs text-muted-foreground">
            O Admin do tenant poderá escolher até {maxIntegrations} integração(ões) das disponíveis
          </p>
        </div>
      )}
    </div>
  );
}
